import React from 'react'
import PropTypes from 'prop-types'

import { Button } from '../Button/Button'
import { StaticFormGroup } from '../StaticFormGroup/StaticFormGroup'
import { ReactModal } from '../ReactModal/ReactModal'
import { InputsFormGroup } from '../InputsFormGroup/InputsFormGroup'
import { polyglot } from '../../../index'

class ExtraFieldsContainer extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      modalIsOpen: false
    }
    this.toggleModal = this.toggleModal.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  toggleModal () {
    this.setState({modalIsOpen: !this.state.modalIsOpen})
  }

  renderSavedFields () {
    return Object.keys(this.props.savedFields).map(element => {
      if (this.props.savedFields[element]) {
        return <StaticFormGroup
          expandInputFields={this.props.expandInputFields}
          handleChanges={this.handleSubmit}
          key={this.props.savedFields[element]}
          label={element}
          value={this.props.savedFields[element]}
          editable />
      }
      return null
    })
  }

  handleSubmit (name, value) {
    this.props.getFieldValue(name, value)
  }

  render () {
    return <div>
      {this.props.savedFields
        ? this.renderSavedFields()
        : null
      }
      <Button text={this.props.buttonText || polyglot.t('staticFields.commonFields.addField')} buttonType='btn-block btn-primary' type='button' onClick={this.toggleModal} />
      <ReactModal name={polyglot.t('staticFields.commonFields.newField')} toggleModal={this.toggleModal} modalIsOpen={this.state.modalIsOpen}>
        <NewFieldModalForm fields={this.props.fields} handleSubmit={this.handleSubmit} toggleModal={this.toggleModal} />
      </ReactModal>
    </div>
  }
}

ExtraFieldsContainer.defaultProps = {
  expandInputFields: false
}

ExtraFieldsContainer.propTypes = {
  fields: PropTypes.object.isRequired,
  savedFields: PropTypes.object,
  getFieldValue: PropTypes.func,
  buttonText: PropTypes.string,
  expandInputFields: PropTypes.bool
}

class NewFieldModalForm extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
    this.handleChanges = this.handleChanges.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleSubmit (e) {
    e.preventDefault()
    this.props.handleSubmit(this.state.name, this.state.value)
  }

  handleChanges (name, value) {
    this.setState({
      [name]: value
    })
  }

  render () {
    return <div className='form-horizontal'>
      <form ref={'form'} onSubmit={e => this.handleSubmit(e)}>
        <InputsFormGroup fields={[
          {
            'name': 'name',
            'placeholder': this.props.fields.type.placeholder,
            'type': 'text'
          }
        ]} label={this.props.fields.type.label} getFieldValue={this.handleChanges} />
        <InputsFormGroup fields={[
          {
            'name': 'value',
            'placeholder': this.props.fields.value.placeholder,
            'type': 'text'
          }
        ]} label={this.props.fields.value.label} getFieldValue={this.handleChanges} />
        <Button text={polyglot.t('staticFields.commonFields.save')} buttonType='btn-block btn-primary' type='submit' onClick={this.props.toggleModal} />
      </form>
    </div>
  }
}

NewFieldModalForm.propTypes = {
  fields: PropTypes.object.isRequired,
  toggleModal: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired
}

export {ExtraFieldsContainer}



// WEBPACK FOOTER //
// ./src/components/common/ExtraFieldsContainer/ExtraFieldsContainer.js